module.exports = __webpack_public_path__ + "fonts/font_IE6.3d2483c7.eot";